import { useState } from "react";
import { Flex, Loader, useMantineTheme } from "@mantine/core";
import {
  ETypeClient,
  IQueryOrder,
  IQueryPosition,
} from "../../../../interfaces/IQuery";
import { OPTIONS_TYPE_CLIENT } from "../../mock";
import { useUserFilter } from "../../../../hooks/useFilterClient";
import { Select } from "../../../../components";
import { ArrowDown2 } from "iconsax-react";
import { useDebouncedValue } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

interface IProps {
  query: IQueryPosition | IQueryOrder;
  setQuery: React.Dispatch<React.SetStateAction<IQueryPosition | IQueryOrder>>;
}

export default function FilterClient({ query, setQuery }: IProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState<ETypeClient>(
    ETypeClient.ALL
  );
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebouncedValue(search, 300);

  const { data, isFetching } = useUserFilter({
    type: selectedType,
    value: debouncedSearch,
  });

  const handleSelectType = (value: ETypeClient) => {
    setSelectedType(value);
    setSearch("");
    setQuery((prev) => ({ ...prev, client_id: null }));
  };

  const handleSelectClient = (value: string) => {
    setQuery((prev) => ({ ...prev, client_id: value }));
  };

  const handleSearchChange = (value: string) => {
    if (value.length < 3) setQuery((prev) => ({ ...prev, client_id: "" }));
    setSearch(value);
  };

  return (
    <Flex
      gap={24}
      wrap={{ base: "wrap", 780: "nowrap" }}
      justify={{ base: "space-between", 780: "flex-end" }}
      align={"end"}
      w="100%"
      miw={{ base: "unset", 780: "450px" }}
    >
      <Select
        data={OPTIONS_TYPE_CLIENT}
        value={selectedType || ""}
        placeholder={t("operacoes.filter_client.select")}
        label={t("operacoes.filter_client.select_client")}
        onChange={handleSelectType}
        w="100%"
      />
      <Select
        w="100%"
        searchable
        placeholder={
          selectedType === ETypeClient.document_nr
            ? t("operacoes.filter_client.write_cpf")
            : selectedType === ETypeClient.email
            ? t("operacoes.filter_client.write_email")
            : selectedType === ETypeClient.name
            ? t("operacoes.filter_client.write_name")
            : t("operacoes.filter_client.select_type")
        }
        nothingFound={
          search.length >= 3 && !isFetching && (data?.length ?? 0) === 0
            ? t("operacoes.filter_client.no_result")
            : undefined
        }
        onSearchChange={handleSearchChange}
        rightSection={
          isFetching ? (
            <Loader size="xs" />
          ) : (
            <ArrowDown2 size="24" color={theme.colors.basic[5]} />
          )
        }
        data={data || ([] as any)}
        searchValue={search}
        value={query.client_id}
        onChange={handleSelectClient}
        disabled={selectedType === ETypeClient.ALL}
      />
    </Flex>
  );
}
